import { format } from "date-fns/format";
function handleDateRangeCalendarChange(setValue, setDefaultMonth, dates) {
    if (dates?.from) {
        setValue('hotelStartDate', format(dates.from, 'yyyyMMdd'));
        setDefaultMonth(dates.from);
        setValue('hotelEndDate', '');
    }
    if (dates?.to) setValue('hotelEndDate', format(dates.to, 'yyyyMMdd'));
}
export { handleDateRangeCalendarChange };
